const en = {
  startPage: {
    selectCountry: 'Country',
    selectCountryDropdown: 'Please select a country',
    statement: 'Please review and accept the',
    termsAndConditions: 'Terms and Conditions',
    statement2: '. This is required before you can continue.',
    seeOur: 'Please note our',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyUrl: 'https://www.medel.com/privacy-policy',
    and: 'and',
    legalNotice: 'Legal Notice',
    legalNoticeUrl: 'https://www.medel.com/legal-notice',
    readTerms: 'Please read Terms and Conditions first to continue',
    continue: 'Continue',
  },
  termsAndConditions: {
    title: 'Terms and Conditions',
    body: 'The Candidate Selection Tool is not a medical device and is not intended to provide treatment or diagnosis. This tool aims to assist health care professionals during the candidate selection process by providing information on the indication criteria for MED-EL’s hearing solutions. The Candidate Selection Tool only provides information on hearing solutions from MED-EL. A health care professional must fully assess the potential risks and benefits for the candidate prior to considering it. The Candidate Selection Tool does not consider reimbursement for the products. Please note that indications and products used within this candidacy tool apply to countries* who accept the CE Mark only.',
    bodyNote: '* The Australian version is specially adapted to their indications',
    accept: 'Accept',
    tooltip: 'I have read the statement above and accept that MED-EL is not taking liability for the treatment of the patient as a result of the usage of this tool.',
    AcceptedAt: 'Accepted at',
  },

  footer: {
    p1: 'MED-EL Medical Electronics. All Rights Reserved',
    p2: 'This tool and its content are based on official MED-EL material, which can also be found at',
    site: 'www.medel.com',
    cookieSettings: 'Cookie Settings',
  },
  getInTouch: {
    title: 'Get in Touch',
    p1: 'Would you like more information on our hearing loss solutions?',
    p2: 'Just fill out our simple contact form and we’ll get back to you.',
    buttonLabel: 'Contact Now',
  },
  common: {
    startAgain: 'Start Again',
    back: 'Back',
    confirm: 'Confirm',
    contact: 'Contact',
    result: 'Result',
    discover: 'Discover More >',
    iAmAware: 'OK',
  },
};

export default en;
